import { Alert } from '@stratascratch/ui'
import { ExecutionResults, ResultsTable } from '@stratascratch/code-editor'

export default function CodingResults({
  results,
}: {
  results: ExecutionResults
}) {
  const executionError = results?.error
  const executionOutput = results?.captured_output
  const tableResults = results?.results
  const officialResults = results?.author_solution_results
  const diffTableResults = results?.results_diff

  const isSubmission = results?.is_solution_submission
  const isCorrectSolution = results?.is_correct_solution
  const showDiffTable =
    isSubmission &&
    !isCorrectSolution &&
    officialResults &&
    diffTableResults &&
    diffTableResults?.missing_user_rows_ids

  return (
    <>
      {executionError && <Alert type="danger">{executionError}</Alert>}
      {(tableResults || executionOutput) && (
        <h4 className="mb-4 text-lg font-bold">Your Results</h4>
      )}
      {showDiffTable && (
        <>
          <Alert type="danger" noIcon>
            Solution is incorrect.
          </Alert>
          <h5 className="mt-4 font-bold">Official solution output</h5>
          <div className="ExecutionResults__table-wrapper">
            <Alert type="info">
              Matched rows are marked green. Missing or incorrect rows are
              marked red.
            </Alert>
            <ResultsTable
              results={officialResults}
              isSubmission={isSubmission}
              wrongRows={diffTableResults.missing_user_rows_ids}
            />
          </div>
        </>
      )}
      {executionOutput && (
        <>
          <h5 className="mt-4 font-bold">Your console output</h5>
          <pre className="mt-4 rounded-lg !p-4 text-sm">{executionOutput}</pre>
        </>
      )}
      {tableResults && (
        <>
          <h5 className="mt-4 font-bold">Your solution output</h5>
          <div className="max-h-96 overflow-auto whitespace-nowrap">
            <ResultsTable
              results={tableResults}
              isSubmission={isSubmission}
              wrongRows={diffTableResults?.missing_author_rows_ids}
            />
          </div>
        </>
      )}
    </>
  )
}
